import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import http from "../http-common";
import useAuth from "./useAuth";

const useTraineeProfile = (uuid) => {
  const { user, isCompetitor } = useAuth();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await http.get(`/internships/trainees/${user.username}`);
        setProfile(result.data);
      } catch (error) {
        // toast.error(error.response?.data.message);
        // if (isCompetitor) {
        //   try {
        //     const result = await http.get(
        //       `/applications/phone/${user.username}`
        //     );
        //     console.log(result.data);
        //   } catch (error) {}
        // }
      }
    };

    fetchData();
  }, []);

  return { profile };
};

export default useTraineeProfile;
